export default __webpack_public_path__ + "static/media/cust1.15f4ee51.jpg";